import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Accordion from '@mui/material/Accordion';
import React, { useState } from 'react'
import HazardLabeledIconWithModal from './HazardLabeledIconWithModal';
import Colors from '../../colors';
import { Box } from '@mui/material';
import AddCustom from './AddCustom';

const detailsStyles = {
    display: 'grid',
    gridTemplateColumns: 'repeat(3, minmax(33%, 1fr))',
    marginBottom: '5px'
}

const containerStyles = {
    boxShadow: '0px 2px 2px rgba(0, 0, 0, 0.2)',
    border: `1px solid ${Colors.green}`,
}

const msgStyles = {
    color: Colors.darkGray,
    fontSize: '18px',
    fontWeight: '600',
    margin: '0 auto',
}

function HazardsAccordion({
    hazardsList, setHazardsList,
    selectedHazards, setSelectedHazards,
    selectedControlMeasures, setSelectedHazardsAndControlMeasures, isEditable }) {

    const [expanded, setExpanded] = useState(false);

    const handleExpansion = (event, isExpanded) => {
        if (isEditable) {
            setExpanded(isExpanded);
        }
    };

    const addNewCustomOnClick = (text) => {
        setHazardsList([...hazardsList, text])
        setSelectedHazards([...selectedHazards, text])
    };

    return (
        <>
            <Accordion
                expanded={expanded}
                onChange={handleExpansion}
                sx={containerStyles} >
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                >
                    {selectedHazards.length > 0 &&
                        <span style={msgStyles}>{`(${selectedHazards.length}) hazards assessed.`}</span>}
                    {selectedHazards.length === 0 &&
                        <span style={msgStyles}>No hazards assessed.</span>}
                </AccordionSummary>

                <AccordionDetails style={detailsStyles}>
                    {hazardsList.map((hazard) => (
                        <HazardLabeledIconWithModal
                            name={hazard}
                            key={hazard}
                            selectedHazards={selectedHazards}
                            setSelectedHazards={setSelectedHazards}
                            selectedControlMeasures={selectedControlMeasures}
                            setSelectedHazardsAndControlMeasures={setSelectedHazardsAndControlMeasures}
                            isEditable={isEditable} />
                    ))}
                    {isEditable && <AddCustom
                        modalLabel={'Add a new custom Hazard to this form?'}
                        inputLabel={'Hazard'}
                        dataCallback={addNewCustomOnClick} />}
                </AccordionDetails>
            </Accordion>
            {!expanded && selectedHazards.length > 0 && (
                <Box
                    sx={[detailsStyles, containerStyles]} >
                    {selectedHazards.sort().map((hazard) => (
                        <HazardLabeledIconWithModal
                            name={hazard}
                            key={hazard}
                            selectedHazards={selectedHazards}
                            setSelectedHazards={setSelectedHazards}
                            selectedControlMeasures={selectedControlMeasures}
                            setSelectedHazardsAndControlMeasures={setSelectedHazardsAndControlMeasures}
                            isEditable={isEditable} />))}
                </Box>
            )}
        </>
    )
}

export default HazardsAccordion;